<template>
  <div>
    <v-row>
      <h4 class="">
        {{ $t("settings.delegationRate.standardDelegationRateVehicle.title") }}
      </h4>
    </v-row>

    <div>
      <v-col>
        <v-form lazy-validation ref="form" v-model="formValid">
          <text-field-with-set-default-checkbox
            :model.sync="delegationRateVehicle.delegation_vehicle_under_900_rate"
            :checkboxText="$t('settings.delegationRate.customDelegationRate.inheritFromParent')"
            :label="$t('settings.delegationRate.standardDelegationRateVehicle.vehicleUnder900')"
            type="number"
          >
          </text-field-with-set-default-checkbox>

          <text-field-with-set-default-checkbox
            :model.sync="delegationRateVehicle.delegation_vehicle_above_900_rate"
            :checkboxText="$t('settings.delegationRate.customDelegationRate.inheritFromParent')"
            :label="$t('settings.delegationRate.standardDelegationRateVehicle.vehicleAbove900')"
            type="number"
          >
          </text-field-with-set-default-checkbox>

          <text-field-with-set-default-checkbox
            :model.sync="delegationRateVehicle.delegation_vehicle_moped_rate"
            :checkboxText="$t('settings.delegationRate.customDelegationRate.inheritFromParent')"
            :label="$t('settings.delegationRate.standardDelegationRateVehicle.moped')"
            type="number"
          >
          </text-field-with-set-default-checkbox>

          <text-field-with-set-default-checkbox
            :model.sync="delegationRateVehicle.delegation_vehicle_motorcycle_rate"
            :checkboxText="$t('settings.delegationRate.customDelegationRate.inheritFromParent')"
            :label="$t('settings.delegationRate.standardDelegationRateVehicle.motorcycle')"
            type="number"
          >
          </text-field-with-set-default-checkbox>
        </v-form>
      </v-col>
    </div>

    <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" block color="accent">{{ $t("global.save") }}</v-btn>

    <h4>{{ $t("settings.delegationRate.standardDelegationRate.title") }}</h4>

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="mx-3">
        <v-checkbox :label="$t('settings.delegationRate.customDelegationRate.showInherited')" v-model="showInherited"></v-checkbox>
      </v-col>
      <v-col class="my-3">
        <DelegationRateFormDialog :group-id="id" @saved="loadList">
          <v-btn block color="accent">{{ $t("settings.delegationRate.standardDelegationRate.addNewRate") }}</v-btn>
        </DelegationRateFormDialog>
      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="filteredDelegationRates" :search="search" :custom-filter="filterOverAllProperty">
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ getCountryTranslatedName(props.item.country_symbol) }}
          </td>
          <td class="text-left">{{ props.item.region }}</td>
          <td class="text-left">{{ props.item.amount }} {{ props.item.currency }}</td>
          <td class="text-left">{{ props.item.hotel_limit }} {{ props.item.currency }}</td>
          <td class="text-center text-no-wrap">
            <span v-if="props.item.group_id === id">
              <DelegationRateFormDialog :id="props.item.id" @saved="loadList" :group-id="id" />
              <v-tooltip bottom>
                {{ $t("global.delete") }}
                <template #activator="{on}">
                  <v-btn @click="remove(props.item)" icon :disabled="$store.getters['Ajax/loading']" v-on="on">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </span>
            <span v-else
              >{{ $t("settings.delegationRate.customDelegationRate.inheritFrom") }}:
              {{ props.item.group_name != null ? props.item.group_name : $t("settings.delegationRate.customDelegationRate.systemSettings") }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TextFieldWithSetDefaultCheckbox from "src/components/CustomInputComponents/TextFieldWithSetDefaultCheckbox.vue";
import CustomDelegationRateVehicle from "src/models/settings/delegationRateVehicleCustom";
import DelegationRateFormDialog from "./DelegationRateFormDialog.vue";
import { getTranslatedCountryName } from "../../../staticData/CountryTypes";
import filterOverAllProperty from "../../../repository/filterOverAllProperty";

export default {
  name: "CustomDelegationRateContent",
  components: { DelegationRateFormDialog, TextFieldWithSetDefaultCheckbox },
  props: {
    id: {
      required: true
    }
  },
  data: () => ({
    delegationRateVehicle: null,
    groups: [],
    formValid: true,
    customDelegationRates: [],
    search: null,
    showInherited: false
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("global.country"), value: "country" },
        { text: this.$t("global.region"), value: "region" },
        { text: this.$t("global.diet"), value: "amount" },
        { text: this.$t("global.hotelLimit"), value: "hotel_limit" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    filteredDelegationRates() {
      let rates = [];
      for (let rate of this.customDelegationRates) {
        if (this.showInherited || rate.group_id === this.id) {
          rates.push(rate);
        }
      }
      return rates;
    }
  },
  methods: {
    filterOverAllProperty: filterOverAllProperty,
    getCountryTranslatedName: getTranslatedCountryName,
    save() {
      this.delegationRateVehicle.save().then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },

    loadList() {
      this.axios.get("settings/delegation-rate/get-effective-delegation-rate?groupId=" + this.id).then(resp => {
        this.customDelegationRates = resp.data;
        for (let index in this.customDelegationRates) {
          this.customDelegationRates[index].countryNamePolish = this.getCountryTranslatedName(this.customDelegationRates[index].country_symbol, "PL");
          this.customDelegationRates[index].countryNameEnglish = this.getCountryTranslatedName(this.customDelegationRates[index].country_symbol, "EN");
        }
      });
    },

    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.content"),
        title: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.title")
      });
      dialog.then(() => {
        this.axios
          .post("settings/delegation-rate/delete-delegation-rate-item", {
            id: item.id
          })
          .then(() => {
            this.loadList();
            this.$store.dispatch("snackbarPush", {
              text: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.snackbar"),
              position: "down"
            });
          });
      });
    }
  },
  created() {
    // this.load();
    this.delegationRateVehicle = new CustomDelegationRateVehicle(this.id);
    this.delegationRateVehicle.load(true);
    this.loadList();
    this.$on("saved", () => {
      this.loadList();
    });
  }
};
</script>

<style scoped></style>
